export function setCredentials(state, credential){
  state.credential=credential;
}